import { FieldGeoJSONQueryOptions, FieldsAPI } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from './queryKey'

export const useFieldSearch = (
  query?: FieldGeoJSONQueryOptions,
  options?: { enabled: boolean },
  skipPointVersions = false
) => {
  const finalQuery = { ...query } as FieldGeoJSONQueryOptions

  return useQuery(
    [QUERY_KEY.FIELDS_MAP_LAYER, finalQuery],
    () => FieldsAPI.geoJSONSearch(finalQuery, skipPointVersions),
    {
      enabled: !!query,
      keepPreviousData: true,
      ...options,
    }
  )
}
